import { Component } from "react";
import Highcharts from "highcharts/highstock";
import Indicators from "highcharts/indicators/indicators";
import HighchartsReact from "highcharts-react-official";
import highchartsMore from "highcharts/highcharts-more.js";
import bb from "highcharts/indicators/bollinger-bands";
import { getChartWorker } from "../../chartWorker";
import {
  formatDecimalNotRound,
  getDeviceInfo,
  getSocket,
  isDesktop,
  isMobile,
  setClassNameCondition,
} from "../../lib/helper";
import { connect } from "react-redux";
import {
  updateChartAction,
  fetchingUser,
  updateAppConfigAction,
  fetchingTransactionAction,
  closeBollinger,
  fetchingTradeDataAction,
  updateTradeDataAction,
} from "../../redux/actions";
import {
  getTradeChartDefault,
  getSMADefault,
  getBollinger,
  getBBArea,
  
} from "../../lib/trade_default_data";
import AnalysisWrapper from "./partial/AnalysisWrapper";
import $, { data } from "jquery";
import _ from "lodash";
Indicators(Highcharts);
bb(Highcharts);
highchartsMore(Highcharts);

const TABS = {
  indicator: "indicator",
  last_result: "last_result",
};

const { deviceVersion } = getDeviceInfo();
const columnLength = deviceVersion === "pc" ? 102 : 40;
class LeftContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: getTradeChartDefault(),
      tab_selected: TABS.last_result,
      trading_data: props.trading_data,
      streak: props.streak,
      is_show_transaction: props.is_show_transaction,
      bollinger_control: true,
      chartHeight: 0,
    };
    this.init_chart = false;
  }
  updateChart(we_price) {
    if (!this.init_chart) return;
    let {
      createDateTime,
      openPrice,
      closePrice,
      baseVolume,
      highPrice,
      lowPrice,
      second,
    } = we_price;

    let btcData = {
      x: createDateTime,
      open: openPrice,
      high: highPrice,
      low: lowPrice,
      close: closePrice,
      vol: baseVolume,
    };
    let volData = {
      x: btcData.x,
      y: btcData.vol,
      color: btcData.open < btcData.close ? "#31BAA0" : "#FC5F5F",
    };
    if (!this.refChart || !this.refChart.chart) return;
    let seriesBTC = this.refChart.chart.series[0];
    let seriesVolume = this.refChart.chart.series[1];
    let { isBollingerClosed } = this.props.headerReducer;
    if (isBollingerClosed) {
      let bollingerSeries = this.refChart?.chart?.series.find(
        (s) => s.name === "bollinger"
      );
      const processXdata = bollingerSeries?.processedXData;
      const processYdata = bollingerSeries?.processedYData;

      let data = [];
      if (processXdata && processYdata) {
        data = processXdata.map((item, index) => {
          return [item, processYdata[index][0], processYdata[index][2]];
        });
      }
      const bbArea = this.refChart?.chart?.series.find(
        (s) => s.name === "BB Area"
      );
      if (bbArea) {
        let bollingerBackgroundVal = getBBArea({ data: data });
        bbArea.update(bollingerBackgroundVal, { animation: { duration: 1000 } });
      } else {
        let bollingerBackgroundVal = getBBArea({ data: data });
        this.refChart?.chart?.addSeries(bollingerBackgroundVal, { animation: { duration: 1000 } });
      }
      if (bollingerSeries) {
        let bollValue = getBollinger();
        bollingerSeries.update(bollValue, { animation: { duration: 1000 } });
      } else {
        let bollValue = getBollinger();
        this.refChart?.chart?.addSeries(bollValue, { animation: { duration: 1000 } });
      }
    }
    ["sma1", "sma2"].forEach((smaName, index) => {
      let smaValue =
        smaName === "sma1"
          ? getSMADefault()
          : getSMADefault({
            name: smaName,
            color: "#c70e65",
            params: {
              index: "0",
              period: 5,
            },
          });
      if (!this.refChart?.chart?.series.find((s) => s.name === smaName)) {
        this.refChart?.chart.addSeries(smaValue, true, {
          duration: 1000,
        });
      } else {
        this.refChart?.chart.series.find((s) => s.name === smaName).update(smaValue);
      }
    });
    let latestBTCPoint = seriesBTC.points[seriesBTC.points.length - 1];
    let latestVolumePoint = seriesVolume.points[seriesVolume.points.length - 1];
    requestAnimationFrame(() => {
      if (latestBTCPoint && createDateTime === latestBTCPoint.x) {
          latestBTCPoint.update(btcData, false);
          latestVolumePoint.update(volData, false);
      } else {
          seriesBTC.addPoint(btcData, false, seriesBTC.data.length > columnLength);
          seriesVolume.addPoint(volData, false, seriesVolume.data.length > columnLength);
      }
      this.refChart.chart.yAxis[0].options.plotLines[0].value = closePrice;
      this.refChart.chart.xAxis[0].options.plotLines[0].value = createDateTime;
      !document.hidden && this.refChart.chart.redraw();
    });
   
   
    let closePriceFormat = formatDecimalNotRound(closePrice, "", 2);
    let secondFormat = "00:" + (second > 9 ? second : "0" + second);
    this.refChart.chart.yAxis[0].options.plotLines[0].label.text =
      '<div class="plotlineChart d-flex flex-column"><span class="price" id="plotLinePrice">' +
      closePriceFormat +
      '</span><span class="time align-self-end" id="timeSecond">' +
      secondFormat +
      "</span></div>";
    $("#plotLinePrice").text(closePriceFormat);
    $("#timeSecond").text(secondFormat);
    if (deviceVersion === "pc") {
      let newMin = seriesBTC?.points[Math.floor(seriesBTC.points.length - 80)]?.x;
      this.refChart?.chart?.xAxis[0]?.setExtremes(newMin, null, false);
    } else {
      let newMin = seriesBTC?.points[Math.floor(seriesBTC.points.length - 19)]?.x;
      this.refChart?.chart?.xAxis[0]?.setExtremes(newMin, null, false);
    }
  }
  getChartHeight() {
    let { deviceVersion } = getDeviceInfo();
    let { isOpen } = this.props
    let { chartHeight } = this.state
    const cropValue = deviceVersion === "pc" ? 180 : 205;
    let t = window.innerHeight - cropValue;
    let c = document.getElementById("analysis-wrapper");
    let e = document.getElementById("candle-wrap");

    let cHeight = c ? c.offsetHeight : 0;
    let eHeight = e ? e.offsetHeight : 0;
    eHeight = t - cHeight;
    if (!isOpen) {
      return deviceVersion === "pc" ? eHeight + 80 : eHeight;
    }  // Đóng PC +80, Mobile không cần
    if (isOpen && chartHeight === eHeight + 80 ||
      isMobile() && isOpen && chartHeight === eHeight) {
        return eHeight - 82;
      } // Sau khi đóng vào và mở lại bị lệch 2px so với chiều cao ban đầu
    return eHeight; // Chiều cao khởi tạo chart
  }
  componentDidMount() {
    this.setState({ chartHeight: this.getChartHeight() });
        this.worker = getChartWorker();  
        getSocket().then((socket) => {
            this.socket = socket;
            this.socket.on("WE_PRICE", (we_price) => {
                this.worker.postMessage({ type: "WE_PRICE", payload: [we_price, !document.hidden] });
            });
        });

        this.worker.onmessage = (e) => {
            if (e.data.type === "WE_PRICE") {
                this.updateChart(e.data.payload[0]);
            }
        };
  }
  
  componentDidUpdate(prevProps, prevState) {
    let chartWidth = null;
    if (prevProps.isOpen !== this.props.isOpen && !this.props.isOpen) {
      this.setState({ chartHeight: this.getChartHeight() }, () => {
         this.refChart.chart.setSize(chartWidth, this.state.chartHeight);
      });
    }

    if (prevState.is_show_transaction !== this.state.is_show_transaction) {
      let e = document.getElementById("binaryPage");
      let d = document.getElementById("analysis-bet-wrapper");
      //Đóng vào
      if (!this.state.is_show_transaction) {
        chartWidth = e.offsetWidth - d.offsetWidth + 200;
      }
      //Mở ra
      else {
        chartWidth = e.offsetWidth - d.offsetWidth * 2;
      }
      this.refChart.chart.update({
        chart: {
          width: chartWidth
        }
      }, false);
    }
      
  }
  updateStreak = () => {
    const streak_content =
      this.state.streak > 0
        ? `<div><div class="streak cursor-pointer"><span class="streak-title text-light">streak</span><div class="ep-container w-[32px] h-[32px]"><div class="ep-content"><div class="ep-svg-container"><svg width="32" height="32" version="1.1" xmlns="http://www.w3.org/2000/svg" class="-rotate-90"><circle r="15.2" cx="16" cy="16" fill="#06354C" stroke="#617F8D" stroke-width="1.6" stroke-dashoffset="0"></circle><circle r="15.2" cx="16" cy="16" stroke="#2AE6D8" stroke-width="1.6" stroke-linecap="round" stroke-dashoffset="95.50441666912971" fill="transparent" stroke-dasharray="95.50441666912971px" class="transition-[stroke-dashoffset] duration-1000 ease-in-out"></circle></svg></div><div class="ep-legend--container absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"><div class="ep-legend--value"><span class="streak-value">x<span>${this.state.streak}</span></span></div></div></div></div></div></div>`
        : "";
    const title = $(".ctitle");
    title.find(".streak").remove();
    title.append(streak_content);
  }
  componentWillReceiveProps(nextProps, nextContext) {
    let { trading_data, streak, is_show_transaction } = nextProps;
    if(this.props.streak !== streak) {
      this.setState({ streak: this.props.streak }, this.updateStreak)
    }
    this.setState({ streak, is_show_transaction });
    if (!this.init_chart && trading_data.length) {
      this.init_chart = true;
      this.setState({ trading_data }, () => this.setChartData(trading_data));
    }
    if(trading_data != this.state.trading_data) {
      this.setState({ trading_data }, () => this.setChartData(trading_data));
    }
  }
  getChartData = (data = []) => {
    if(!data.length) return [[], []];
    let btcDataList = [];
    let volDataList = [];
    let dataForOption = data.slice(
      data.length - columnLength
    );
    dataForOption
      .filter(item => item !== null && item !== undefined)
      .forEach(
        ({
          createDateTime,
          openPrice,
          closePrice,
          baseVolume,
          highPrice,
          lowPrice,
        }) => {
          let btcData = {
            x: createDateTime,
            open: openPrice,
            high: highPrice,
            low: lowPrice,
            close: closePrice,
            vol: baseVolume,
          };
          let volData = {
            x: btcData.x,
            y: btcData.vol,
            color: btcData.open < btcData.close ? "#31BAA0" : "#FC5F5F",
          };

          btcDataList.push(btcData);

          volDataList.push(volData);
        }
      );
      return [btcDataList, volDataList];
  }
  setChartData = (data) => {
    const {chartHeight} = this.state;
    let [btcDataList, volDataList] = this.getChartData(data);
    this.refChart.chart.update({
      chart: {
        height: chartHeight
      },
      series: [{
        name: 'ETH/USDT',
        data: btcDataList
      }, {
        name: 'Volume',
        data: volDataList
      }]
    },false);
    let newMin;
      if (deviceVersion === "pc") {
        newMin = btcDataList[Math.floor(btcDataList.length - 80)]?.x;
      } else {
        newMin = btcDataList[Math.floor(btcDataList.length - 19)]?.x;
      }
    let options = getTradeChartDefault({
      "series[0].data": btcDataList,
      "series[1].data": volDataList,
      "chart.height": chartHeight,
      "xAxis.min": newMin,
    });
    this.refChart.chart.xAxis[0].setExtremes(newMin, null, true, {
      duration: 1000,
      easing: 'easeOutExpo'
    });
    this.setState({ options });
  }
  componentWillUnmount() {
    this.init_chart = false;
    window.socket && window.socket.removeAllListeners("WE_PRICE");
  }

  // Tránh render lại không cần thiết
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.options !== nextState.options || this.state.is_show_transaction !== nextState.is_show_transaction) {
      return true;
    }
    if (this.props.headerReducer.isBollingerClosed !== nextProps.headerReducer.isBollingerClosed ||  this.props.isOpen !== nextProps.isOpen) {
      return true;
    }
    return false;
  }
  render() {
    let { is_show_transaction } = this.props.appReducer;
    return (
      <div
        data-v-5b2de64c=""
        id="leftContent"
        className={
          "leftContent " +
          (is_show_transaction ? "" : "hideTransaction") +
          (isDesktop() ? " h-100" : "")
        }
      >
        <div
          data-v-5b2de64c=""
          className={setClassNameCondition(isDesktop(), "h-100 d-flex flex-column", "", "")}
        >
          <div
            data-v-49a1c76e=""
            data-v-5b2de64c=""
            id="candle-wrap"
            className="postion-relative chartBox"
          // style={{
          //   height: isDesktop() ?
          //     `calc(100vh - ${this.props.isOpen ? "323px" : "120px"})`
          //     : `calc(100vh - ${this.props.isOpen ? "150px" : "320px"})`
          // }}
          >
            <div
              data-v-30eeb0ce=""
              data-v-49a1c76e=""
              className="indicatorsPopup"
            >
              <div data-v-30eeb0ce="" className="position-relative">
                <button
                  data-v-30eeb0ce=""
                  type="button"
                  className="btnIndicator d-flex align-items-center justify-content-center"
                >
                  <img
                    data-v-30eeb0ce=""
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTciIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxNyAyMiI+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+CiAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfNTA3OCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNTA3OCIgd2lkdGg9IjE3IiBoZWlnaHQ9IjIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDQuODU4IDEwMi41NTgpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPGcgaWQ9Ik1hc2tfR3JvdXBfNjE3IiBkYXRhLW5hbWU9Ik1hc2sgR3JvdXAgNjE3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQ0Ljg1OCAtMTAyLjU1OCkiIGNsaXAtcGF0aD0idXJsKCNjbGlwLXBhdGgpIj4KICAgIDxnIGlkPSJHcm91cF8yMTUzOSIgZGF0YS1uYW1lPSJHcm91cCAyMTUzOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM4Ljg0MSAxMTcuMjkyKSByb3RhdGUoLTQ1KSI+CiAgICAgIDxnIGlkPSJHcm91cF8yMTUzOCIgZGF0YS1uYW1lPSJHcm91cCAyMTUzOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfMzUzNTYiIGRhdGEtbmFtZT0iUGF0aCAzNTM1NiIgZD0iTTE5LjkwNy4zYS45ODIuOTgyLDAsMCwwLTEuNDIyLDBMMTYuOTYyLDEuODI4YTIuOTc5LDIuOTc5LDAsMCwwLTMuNTU1LjYwOSwzLjcyOSwzLjcyOSwwLDAsMC0uOTE0LDIuMDMxTDkuMTQxLDUuNDg1LDcuODIxLDMuODZBMS4wMDUsMS4wMDUsMCwxLDAsNi40LDUuMjgybC43MTEuODEzTDMuMjUsNy4yMTFhMS4xLDEuMSwwLDAsMC0uODEzLjgxM0wwLDkuMTQxbDIuNTM5LS40MDZhMS4wMzUsMS4wMzUsMCwwLDAsMS4xMTcuNTA4TDguNzM1LDcuNzE5bDMuODYsMy44Ni0xLjUyNCw1LjA3OGExLDEsMCwwLDAsLjUwOCwxLjExN2wtLjQwNiwyLjUzOSwxLjExNy0yLjQzOEExLjIyNywxLjIyNywwLDAsMCwxMywxNy4xNjVsMS4xMTctMy44Ni43MTEuNzExYTEuMDA1LDEuMDA1LDAsMCwwLDEuNDIyLTEuNDIybC0xLjUyNC0xLjUyNCwxLjAxNi0zLjM1MmEyLjg3MywyLjg3MywwLDAsMCwyLjAzMS0uOTE0LDMuMjU2LDMuMjU2LDAsMCwwLC42MDktMy41NTVsMS41MjQtMS41MjRBLjk4Mi45ODIsMCwwLDAsMTkuOTA3LjNabS02LjcsOS4wNEwxMC45NjksNy4xMSwxMy4yLDYuNGE0LjU4NSw0LjU4NSwwLDAsMCwuNzExLjcxMVptMy4yNS00LjA2M0ExLjAwNSwxLjAwNSwwLDAsMSwxNS4wMzIsMy44NmExLjIxOCwxLjIxOCwwLDAsMSwxLjQyMiwwQS45ODIuOTgyLDAsMCwxLDE2LjQ1NCw1LjI4MloiIGZpbGw9IiNmZmYiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="
                  />
                </button>
                <div data-v-30eeb0ce="" />
              </div>
            </div>
            <HighchartsReact
              ref={(ref) => (this.refChart = ref)}
              highcharts={Highcharts}
              constructorType={"stockChart"}
              options={this.state.options}
              containerProps={{
                className: "candelstick-chart-instance",
                id: "chart-instance",
              }}
            />
            <div
              data-v-49a1c76e=""
              className="h-100"
              style={{ display: "none" }}
            >
              <div
                data-v-49a1c76e=""
                className="h-100 d-flex align-items-center justify-content-center"
              >
                <div data-v-49a1c76e="" className="circle">
                  Không có dữ liệu
                </div>
              </div>
            </div>
          </div>
          {isDesktop() && (
            <AnalysisWrapper
              trading_data={this.state.trading_data}
              isOpen={this.props.isOpen}
              handleToggleIncaditor={this.props.handleToggleIncaditor}
            />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    chartReducer: state.chartReducer,
    memberReducer: state.memberReducer,
    appReducer: state.appReducer,
    headerReducer: state.headerReducer,
    tradeReducer: state.tradeReducer,
  };
}

export default connect(mapStateToProps, {
  updateChartAction,
  fetchingUser,
  updateAppConfigAction,
  fetchingTransactionAction,
  closeBollinger,
  fetchingTradeDataAction,
  updateTradeDataAction,
})(LeftContent);
